module.exports = __webpack_public_path__ + "static/media/JP_RS_EYELASHES03.80278885.jpg";